module.exports = __webpack_public_path__ + "static/media/instagram-red.8c1d56eb.png";